import { createEffect, createEvent, createStore, sample } from 'effector';
import { api, unwrap, type Schemas } from '../../shared/api/client';

export const marketRefreshed = createEvent();

export const loadStatusFx = createEffect(() => unwrap(api.GET('/api/v1/market/status')));
export const loadWatchlistFx = createEffect(() => unwrap(api.GET('/api/v1/market/watchlist')));

export const $marketStatus = createStore<Schemas['MarketStatusOut'] | null>(null).on(
  loadStatusFx.doneData,
  (_, status) => status,
);

export const $watchlist = createStore<Schemas['WatchItemOut'][] | null>(null).on(
  loadWatchlistFx.doneData,
  (_, items) => items,
);

sample({ clock: marketRefreshed, target: [loadStatusFx, loadWatchlistFx] });

// Daily closes per instrument for price charts, cached for the visit.
export const loadBarsFx = createEffect((instrumentId: number) =>
  unwrap(
    api.GET('/api/v1/market/bars', {
      params: { query: { instrument_id: instrumentId, days: 183 } },
    }),
  ),
);

export const $bars = createStore<Record<number, Schemas['BarOut'][]>>({}).on(
  loadBarsFx.done,
  (cache, { params, result }) => ({ ...cache, [params]: result }),
);
